<template>
  <div class="row my-2">
    <div class="col-9">
      <label>Url</label>
    </div>
    <div class="col-3">
      <label>Profundidad</label>
    </div>
    <div class="col-10">
      <input v-on:blur="save_url" class="form-control" type="text" v-model="url_buffer" placeholder="google.com">
    </div>
    <div class="col-2">
      <input v-on:blur="save_url" class="form-control" type="number" v-model="depth_buffer" placeholder="1">
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      url_buffer:this.$props.url,
      depth_buffer:this.$props.depth,
    }
  },
  props:{
    index:{required:true, default: 0},
    url: {required:false, default: ''},
    depth: {required:false}
  },
  methods:{
    save_url(){
      this.$emit('save_url',this.index,this.url_buffer,this.depth_buffer)
    },
  },

}
</script>

<style>
</style>
